<app-layout>
  <app-voltar [route]="onVoltar()" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>
  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          type="text"
          label="Nome do motorista"
          name="NM_USUA_MTRT"
          [requiredInput]="true"
          formControlName="NM_USUA_MTRT"
          placeholder="Digite aqui"></app-input>

        <app-input
          type="text"
          label="CPF"
          name="TX_CPF_MTRT"
          formControlName="TX_CPF_MTRT"
          [requiredInput]="true"
          mask="000.000.000-00"
          placeholder="___.___.___-__"></app-input>

        <app-input
          type="text"
          label="Número da CNH"
          name="TX_CNH_MTRT"
          mask="000000000"
          formControlName="TX_CNH_MTRT"
          placeholder="Digite aqui"></app-input>

        <app-input
          type="text"
          label="Telefone"
          name="NU_TELE_MTRT"
          formControlName="NU_TELE_MTRT"
          mask="(00) 00000-0000"
          placeholder="(__) _____-____"></app-input>

        <app-input
          type="email"
          label="Email"
          name="TX_MAIL_MTRT"
          formControlName="TX_MAIL_MTRT"
          [requiredInput]="true"
          maxLength="100"
          mask="A*"
          placeholder="exemplo@exemplo.com"></app-input>

        <app-input
          label="CEP"
          name="TX_ENDE_CEP_FUNC"
          formControlName="TX_ENDE_CEP_FUNC"
          placeholder="_____-___"
          mask="00000-000"
          (ngModelChange)="consultaCEP()"></app-input>

        <app-input
          label="Estado"
          name="TX_ENDE_ESTD_FUNC"
          formControlName="TX_ENDE_ESTD_FUNC"
          placeholder="Digite aqui"
          maxLength="2"></app-input>

        <app-input
          label="Cidade"
          name="TX_ENDE_CDDE_FUNC"
          formControlName="TX_ENDE_CDDE_FUNC"
          placeholder="Digite aqui"
          maxLength="50"></app-input>

        <app-input
          label="Endereço"
          name="TX_ENDE_RUA_FUNC"
          formControlName="TX_ENDE_RUA_FUNC"
          placeholder="Digite aqui"
          maxLength="50"></app-input>

        <span></span>

        <app-input
          type="password"
          label="Senha"
          name="TX_SENH"
          formControlName="TX_SENH"
          maxLength="15"
          placeholder="Digite aqui"
          [requiredInput]="!title.includes('Editar')"
          (ngModelChange)="confirmacaoSenha()"></app-input>

        <app-input
          type="password"
          label="Confirme a senha"
          name="TX_SENH_CNFRM"
          formControlName="TX_SENH_CNFRM"
          maxLength="15"
          placeholder="Digite aqui"
          [requiredInput]="!title.includes('Editar')"
          (ngModelChange)="confirmacaoSenha()"></app-input>

        <div
          class="validators"
          *ngIf="this.form.controls['TX_SENH']?.value?.length">
          <p [ngClass]="{ valid: isLengthValid, invalid: !isLengthValid }">
            No mínimo 8 caracteres
          </p>
          <p [ngClass]="{ valid: hasNumber, invalid: !hasNumber }">
            Pelo menos um número
          </p>
          <p [ngClass]="{ valid: hasLowercase, invalid: !hasLowercase }">
            No mínimo 1 caractere minúsculo
          </p>
          <p [ngClass]="{ valid: hasUppercase, invalid: !hasUppercase }">
            No mínimo 1 caractere maiúsculo
          </p>
          <p [ngClass]="{ valid: hasSpecialChar, invalid: !hasSpecialChar }">
            No mínimo 1 caractere especial
          </p>
          <p [ngClass]="{ valid: passwordsMatch, invalid: !passwordsMatch }">
            As senhas devem ser iguais
          </p>
        </div>
      </div>
      <app-botao
        *ngIf="!disabledMotorista"
        type="cadastro"
        class="botao-cadastro"
        [disabled]="!form.valid && !passwordsMatch"
        [text]="isEditing ? 'Salvar Edição' : 'Cadastrar'"
        (click)="postDados()"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
